import React, { Component } from 'react'
import { InformationCircleIcon } from '@heroicons/react/outline'

// Bulle d'aide au survol / focus (et tap sur tactile). Composant classe (React 16),
// état géré en JS — on ne dépend pas de group-hover (non garanti en Tailwind 2.2 sans JIT).
class InfoTip extends Component {
	constructor(props) {
		super(props)
		this.state = { show: false }
	}

	_open = () => {
		this.setState({ show: true })
	}

	_close = () => {
		this.setState({ show: false })
	}

	_toggle = () => {
		const next = !this.state.show
		this.setState({ show: next })
	}

	render() {
		return (
			<span className="relative inline-flex items-center align-middle">
				<button
					type="button"
					aria-label="Plus d'informations"
					onMouseEnter={this._open}
					onMouseLeave={this._close}
					onFocus={this._open}
					onBlur={this._close}
					onClick={this._toggle}
					className="inline-flex items-center justify-center p-0 cursor-pointer text-slate-300 hover:text-slate-500 focus:text-slate-500 focus:outline-none"
					style={{ backgroundImage: 'none', backgroundColor: 'transparent', height: 'auto', lineHeight: 0 }}
				>
					<InformationCircleIcon className="w-4 h-4" aria-hidden="true" />
				</button>
				{this.state.show &&
					<span
						role="tooltip"
						className="absolute left-0 top-full mt-1.5 z-50 w-52 normal-case tracking-normal bg-slate-800 text-white text-xs font-medium leading-snug rounded-lg shadow-lg p-3"
					>
						{this.props.text}
					</span>
				}
			</span>
		)
	}
}

export default InfoTip
